import cx from 'classnames';
import './../assets/scss/_accordion.scss';
import { Accordion, AccordionContext, useAccordionButton } from 'react-bootstrap';
import { useContext } from 'react';

function CustomToggle({ children, eventKey, callback }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => callback?.(eventKey));

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <button
      type="button"
      className={cx('toggle-btn', isCurrentEventKey ? '' : 'collapsed')}
      onClick={decoratedOnClick}>
      {children}
    </button>
  );
}

export const AccordionCard = ({
  id = null,
  title = null,
  description = '',
  children = null,
  className = '',
  style = {},
  open = false,
  expandableIconType = 'PLUS', // ANGLE, PLUS
  onClick = () => {},
  alwaysOpen = false,
  useCustomToggle = false,
  defaultActiveKey = null,
}) => {
  if (!id || !title) return null;

  if (useCustomToggle) {
    const _id = defaultActiveKey !== null ? defaultActiveKey : id;

    return (
      <Accordion
        defaultActiveKey={_id}
        className={className}
        style={style}
        alwaysOpen={alwaysOpen}
        open={open}
        flush={true}>
        <div
          className="accordion-header d-flex align-items-center justify-content-between gap 2"
          onClick={onClick}>
          {title} <CustomToggle eventKey={_id} />
        </div>
        <Accordion.Collapse eventKey={_id}>{description || children}</Accordion.Collapse>
      </Accordion>
    );
  }

  return (
    <div className={cx('accordion-item', className)} style={style}>
      <h2 className="accordion-header" id={`panelsStayOpen-heading${id}`} onClick={onClick}>
        <div
          className={cx(
            'accordion-button d-flex justify-content-between bg-transparent',
            open ? '' : 'collapsed',
            expandableIconType === 'ANGLE' ? 'angle' : 'plus'
          )}
          data-bs-toggle="collapse"
          data-bs-target={alwaysOpen ? '' : `#panelsStayOpen-collapse${id}`}
          aria-expanded={open ? 'true' : 'false'}
          aria-controls={`panelsStayOpen-collapse${id}`}>
          <div className="main-text">{title}</div>
        </div>
      </h2>
      <div
        id={`panelsStayOpen-collapse${id}`}
        className={cx('accordion-collapse collapse', open ? 'show' : '')}
        aria-labelledby={`panelsStayOpen-heading${id}`}>
        <div className="accordion-body">{description || children}</div>
      </div>
    </div>
  );
};
